import classNames from "classnames";
import { ViewPrep } from "components/organisms/ViewPrep";
import { Typography } from "components/atoms/Typography";
import "./index.scss";

interface IProps {
  theme: "light" | "dark";
}

export const ViewPrepPage = ({ theme }: IProps) => {
  return (
    <div className={classNames("view-prep-page-parent-wrapper")}>
      <div className={classNames("view-prep-page-wrapper")}>
        <div className={classNames("view-prep-page-title-wrapper")}>
          <div className={classNames("view-prep-page-title-mark")}></div>
          <Typography variant="h2Bold" label="Prep Information" />
        </div>
        <ViewPrep theme={theme} />
      </div>
    </div>
  );
};
